import styled, { keyframes } from "styled-components";
import COLORS from "../../Theme/Colors";
import BREAKPOINTS from "../../Theme/Breakpoints";

export const colorChange = keyframes`
  0% { color: ${COLORS.black}; }
  50% { color: ${COLORS.red}; }
  100% { color: ${COLORS.black}; }
`;

export const Wrapper = styled.div`
  margin: auto;
  padding: 3rem 3rem 0;
  max-width: 1320px;
  border-radius: 1rem;
  margin-top: 7.6rem;
  background-image: linear-gradient(
    to top,
    #f3e7e9 0%,
    #e3eeff 99%,
    #e3eeff 100%
  );

  ${BREAKPOINTS.TABLET} {
    margin: 8rem 2rem 0;
    padding: 2rem 6rem 0;
  }

  ${BREAKPOINTS.MOBILE} {
    margin: 7rem 1rem 0;
    padding: 3.4rem 2rem 0;
  }
`;

export const HeroWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  max-width: 1080px;
  line-height: 5rem;

  ${BREAKPOINTS.DESKTOP} {
    line-height: 4rem;
  }

  ${BREAKPOINTS.TABLET} {
    line-height: 3.5rem;
  }

  ${BREAKPOINTS.MOBILE} {
    flex-direction: column;
    line-height: 3rem;
  }

  h1,
  h2 {
    margin: 0;
  }

  h1 {
    font-family: "Poppins", sans-serif;
    font-weight: 700;

    ${BREAKPOINTS.MOBILE} {
      font-size: 2.5rem;
    }
    ${BREAKPOINTS.TABLET} {
      font-size: 3rem;
    }
    ${BREAKPOINTS.DESKTOP} {
      font-size: 3.5rem;
    }
    font-size: 4rem;
  }

  h2 {
    font-family: "Alkatra", sans-serif;
    font-weight: 300;

    ${BREAKPOINTS.MOBILE} {
      font-size: 2.2rem;
    }
    ${BREAKPOINTS.TABLET} {
      font-size: 2.5rem;
    }
    ${BREAKPOINTS.DESKTOP} {
      font-size: 3rem;
    }
    font-size: 4rem;
  }
`;

export const Title = styled.div`
  ${BREAKPOINTS.MOBILE} {
    text-align: center;
    margin-bottom: 14px;
  }
`;

export const RedText = styled.span`
  color: ${COLORS.black};
  animation: ${colorChange} 3s infinite;
  font-family: "Alkatra", sans-serif;
`;

export const HeroImage = styled.img`
  width: 50%;

  ${BREAKPOINTS.MOBILE} {
    width: 100%;
  }
`;
